import { PermissionsScope } from '../policies/policy.model'

export const PAYMENT_SCOPE: PermissionsScope = 'payments'
export const PAYMENT_FRAGMENT = 'payment'
